"use client"
import { useEffect, useState } from "react"

import { selectsoftLoginUI } from "stores/auth/authSlice"
import { SoftLoginModalType } from "stores/auth/types"
import { useAppSelector } from "stores/hooks"
import { getSoftLoginData, setSoftLoginDataInLS } from "utils/local-storage"

export interface SoftLoginData {
  userId: number
  emailId: string
  softLoginType: SoftLoginModalType
  isSoftLogingFromFavOrPDA?: boolean
  isSoftLogingFromMessageHost?: boolean
  // softLoginMethod: "EMAIL" | "GOOGLE" | "APPLE",
}
export const useSoftLoginDataFromLocalStorage = () => {
  const [softLoginData, setSoftLoginData] = useState<SoftLoginData | null>(null)
  const { isUserSoftLoggedIn } = useAppSelector(selectsoftLoginUI)
  const updatedSoftLoginData = (data: Partial<SoftLoginData>) => {
    const dataFromLocal = getSoftLoginData()
    if (softLoginData?.userId && dataFromLocal) {
      setSoftLoginDataInLS({
        ...dataFromLocal,
        ...data,
      })
    }
  }
  useEffect(() => {
    const data = getSoftLoginData()
    setSoftLoginData(data)
  }, [isUserSoftLoggedIn])

  return { softLoginData, updatedSoftLoginData }
}
